import { ClassSessionType } from "components/server-types";

export const isClassSessionActive = (classSession: ClassSessionType) => {
  return !!classSession.started_at && classSession.ended_at === null;
};

export const getActiveClassSession = (classSessions: ClassSessionType[]) => {
  return classSessions.find(isClassSessionActive) || null;
};
